<template>
  <div class="new_vip">
    <div class="content">
      <Role></Role>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Role from "@/views/apply/employee/roleAdd"
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
    }
  },
  components: {
    Role
  }
}
</script>

<style lang="scss" scoped>
.new_vip{
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  .content{
    background: #fff;
    overflow: auto;
    height: 100%;
  }
}
</style>